import { t } from '@/config/vue-i18n'

export function localize(obj, isUsingFallback = true) {
  return On.helpers.localize(obj, isUsingFallback)
}

export function isTranslationAvailable(key) {
  return t(key) !== key
}
